module.exports = __webpack_public_path__ + "static/media/whatsapp_icon.1f499a4d.svg";